
<div id="app" class="m-auto fullWidth">
  <transition name="fade">
    <RouterView />
  </transition>
  <div class="loading-warp" v-if="publicLoading.loading">
    <div class="loading-box">
      <img width="100" src="@/assets/loading.jpg" alt="" />
      <span>{{ publicLoading.text }}</span>
      <!-- <van-loading color="#0094ff" text-color="#0094ff" class="loading">
        {{ publicLoading.text }}
      </van-loading> -->
    </div>
  </div>
</div>
